import practiceInfo from "./practiceInfo.js";
import generalPerferences from "./generalPerferences.js";
import notificationPerferences from "./notificationPerferences.js";
import patientNavigation from "./patientNavigation.js"
import billing from "./billing.js";
import payoutSetting from "./payoutSetting.js";
import account from "./account.js"
import userInfo from './userInfo.js'
import reportPreferences from './reportPreferences.js'
import clinicDashboard from './clinicDashboard.js'
const myPractice = {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {},
  modules: {
    practiceInfo,
    generalPerferences,
    notificationPerferences,
    patientNavigation,
    billing,
    payoutSetting,
    account,
    userInfo,
    reportPreferences,
    clinicDashboard
  }
}

export default myPractice;